export const TRANSACTION_TYPES = {
  new_residence: ['زيارة أولى', 'دبي للتأمين', 'مصاريف العمل', 'إصدار تأشيرة داخل الدولة', 'إصدار تأشيرة خارج الدولة', 'تعديل وضع', 'مخالفات الجوازات', 'توجيه', 'التعطل عن العمل', 'غرامة التعطل عن العمل', 'فحص طبي', 'هوية', 'الإقامة', 'مخالفات العمل', 'طلب استرحام'],
  renewal: ['تجديد عقد العمل', 'دبي للتأمين', 'مصاريف العمل', 'توجيه', 'مخالفات العمل', 'التعطل عن العمل', 'غرامة التعطل عن العمل', 'فحص طبي', 'تجديد الهوية', 'الإقامة', 'مخالفات الجوازات'],
  cancellation: ['إلغاء ملف العمل', 'إلغاء الجوازات', 'الغاء عامل خارج الدوله جوازات', 'الغاء عامل خارج الدوله عمل', 'الغاء تصريح عمل مؤقت 6 اشهر', 'الغاء تصريح عمل مؤقت عامين'],
  temp_work_permit: ['تصريح عمل مؤقت 6 أشهر', 'تصريح عمل مؤقت سنتين', 'دبي للتأمين', 'تسليم تصريح 6 أشهر', 'تسليم تصريح سنتين'],
  partial_work: ['تصريح عمل بعض الوقت', 'دبي للتأمين', 'تسليم تصريح عمل لبعض الوقت']
};

export const SUB_TYPE_EN = {
  // New Residence
  'زيارة أولى': 'First Visit',
  'دبي للتأمين': 'Dubai Insurance',
  'مصاريف العمل': 'Labor Payment',
  'إصدار تأشيرة داخل الدولة': 'New Visa (INSIDE Country)',
  'إصدار تأشيرة خارج الدولة': 'New Visa (Outside Country)',
  'تعديل وضع': 'Change Status',
  'مخالفات الجوازات': 'Immigration Violation',
  'توجيه': 'TAW-JEEH',
  'التعطل عن العمل': 'ILOE Insurance',
  'غرامة التعطل عن العمل': 'ILOE Fine',
  'فحص طبي': 'Medical Test',
  'هوية': 'ID Application',
  'الإقامة': 'Visa Stamp',
  'مخالفات العمل': 'MOHRE Fine',
  'طلب استرحام': 'Clemency Request',
  'مخالفات الهوية': 'ID FINE',
  // Renewal
  'تجديد عقد العمل': 'Renew Contract',
  'تجديد الهوية': 'Renew ID Application',
  'مخالفات التعطل': 'ILOE FINE',
  // Cancellation
  'إلغاء ملف العمل': 'Labor Card Cancellation',
  'إلغاء الجوازات': 'Immigration Cancellation',
  'إلغاء عامل خارج الدولة': 'Outside Immigration Cancellation',
  'الغاء عامل خارج الدوله جوازات': 'Outside Immigration Cancellation',
  'الغاء عامل خارج الدوله عمل': 'Outside Labor Cancellation',
  'طباعه كشف بيان حركة': 'TRAVILE REPORT',
  'الغاء تصريح عمل مؤقت 6 اشهر': 'TM MOHRE Cancellation 6 Months',
  'إلغاء تصريح عمل مؤقت 6 أشهر': 'TM MOHRE Cancellation 6 Months',
  'الغاء تصريح عمل مؤقت عامين': 'Cancel TM Labor 2 Years',
  // Temporary Work Permit
  'تصريح عمل مؤقت 6 أشهر': 'TM Contract 6 Months',
  'تصريح عمل مؤقت سنتين': 'TM Contract 2 Years',
  'تسليم تصريح 6 أشهر': 'Submit TM Contract 6 Months',
  'تسليم تصريح سنتين': 'Submit TM Contract 2 Years',
  // Partial Work
  'تصريح عمل بعض الوقت': 'TP Work Permit',
  'تسليم تصريح عمل لبعض الوقت': 'Submit TP Work Permit',
  // GCC Work Permit
  'عقد عمل مواطن': 'LOCAL CONTRACT',
  'تسليم تصريح عمل مواطن': 'SUBMIT LOCAL CONTRACT',
  // Legacy (for old data)
  'تصريح عمل مؤقت + تسليم': 'Temp Work Permit + Delivery',
  'تسليم التصريح': 'Permit Delivery'
};

// Normalize Arabic text for matching (remove hamza variations)
const normalizeAr = (text) => {
  if (!text) return '';
  return text
    .replace(/[إأآا]/g, 'ا')
    .replace(/[ؤ]/g, 'و')
    .replace(/[ئ]/g, 'ي')
    .replace(/ة/g, 'ه')
    .trim();
};

export const translateSubType = (subType, isRTL) => {
  if (isRTL) return subType;
  // Direct match first
  if (SUB_TYPE_EN[subType]) return SUB_TYPE_EN[subType];
  // Normalized match (handles hamza variations)
  const norm = normalizeAr(subType);
  for (const [key, val] of Object.entries(SUB_TYPE_EN)) {
    if (normalizeAr(key) === norm) return val;
  }
  return subType;
};
